import { EstadoFichaClinica } from '../enums';

export const fichaClinicaFinalizada = (estado: string): boolean => {
  return (
    estado !== EstadoFichaClinica.AGENDADA &&
    estado !== EstadoFichaClinica.PROCESO
  );
};
